import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type CreateRelyingPartyRequestResponse = {
    response: AxnRelyingParty;
};

export const createRelyingPartyRequest = async (
    companyID: string,
    name: string
): Promise<GenericNetworkResponse<CreateRelyingPartyRequestResponse>> => {
    const route = apiRoutes.axnadminCore.axn.relyingparty;
    const body = {
        companyID,
        name
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};